<template>
<div class="container">
    <div class="step">
        <van-steps :active="active" active-color="#38f">
            <van-step>登录商城</van-step>
            <van-step>输入卡号</van-step>
            <van-step>输入卡密</van-step>
            <van-step>激活成功</van-step>
        </van-steps>
    </div>
    <!-- <van-field v-model="memberName" label="姓名：" placeholder="请输入姓名"/> -->
    <!-- <van-field v-model="mobileNo" label="电话：" @blur="validPhone()" placeholder="请输入注册手机号"/> -->
    <van-field v-model="cardNo" label="卡号：" placeholder="请输入卡号"/>
    <van-field v-model="cardPassword" label="卡密：" placeholder="请输入卡密"/>
    <div class="item" v-if="this.$route.query.cardSort==2 || this.$route.query.cardSort==3" >
        <div class="label">上传发票：</div>
        <div class="photo">
            <van-uploader v-model="fileList" multiple :after-read="afterRead" />
        </div>
    </div>
    <!-- <div class="item">
        <div class="label">验证码：</div>
        <div>
          <input type="text" placeholder="请输入内容" />
        </div>
        <div class="Verification">
          <img src="" alt="" />
          <span>看不清？</span>
        </div>
      </div> -->
    <!-- <div class="vation">

        <div class="item">
            <div class="label">请输入姓名：</div>
            <div>
                <input type="text" placeholder="请输入内容" v-model="memberName" />
            </div>
        </div>
        <div class="item">
            <div class="label">请输入联系电话：</div>
            <div>
                <input type="text" placeholder="请输入内容" v-model="mobileNo" maxlength="11" @blur="validPhone()" />
            </div>
        </div>
        <div class="item">
            <div class="label">卡号：</div>
            <div>
                <input type="text" placeholder="请输入内容" v-model="cardNo" />
            </div>
        </div>
        <div class="item">
            <div class="label">卡密：</div>
            <div>
                <input type="text" placeholder="请输入内容" v-model="cardPassword" />
            </div>
        </div>

    </div> -->
    <van-button round type="primary" @click="submit()">下一步</van-button>
</div>
</template>

<script>
import {
    activateCardPoint,
    uploadImg
} from '@/api/api'
export default {
    components: {},
    props: {},
    data() {
        return {
            // memberName: null,
            // mobileNo: null,
            dialogImageUrl: "",
            dialogVisible: false,
            cardPassword: null,
            cardNo: null,
            imgUrl: null,
            cardSort: null,
            active: 2,
            phone: null,
            fileList: [],
        };
    },
    watch: {},
    computed: {},
    methods: {
        async afterRead(file) {
            // 此时可以自行将文件上传至服务器
            var formData = new FormData();

            //可以通过append()方法来追加数据
            formData.append("file", file.file);
            console.log(formData)
            const res = await uploadImg(formData);
            if (res.code == "0000") {
                this.imgUrl = res.data;
            }
        },
        // validPhone() {
        //     if (!/^1[3456789]\d{9}$/.test(this.mobileNo)) {
        //         this.$toast("请输入正确的手机号");
        //         return;
        //     }
        // },
        async submit() {
            // if (!this.mobileNo) {
            //     this.$toast("请输入手机号");
            //     return;
            // }
            // if (!/^1[3456789]\d{9}$/.test(this.mobileNo)) {
            //     this.$toast("请输入正确的手机号");
            //     return;
            // }

            if (this.imgUrl == null && (this.cardSort == 2 || this.cardSort == 4)) {
                this.$toast("请上传发票图片");
            }

            let params = {
                // "memberName": this.memberName,
                "cardNo": this.cardNo,
                // "mobileNo": this.mobileNo,
                "imageUrl": this.imgUrl,
                "cardPassword": this.cardPassword
            };
            let pointCard = await activateCardPoint(params)
            if (pointCard.code == '0000') {
                this.$router.push({
                    path: '/Activationsuccessful',
                    query: {
                        msg: pointCard.msg,
                    }
                });
            } else {
                this.$toast(pointCard.msg);
            }

        },
    },
    created() {},
    mounted() {
        this.cardNo = this.$route.query.cardNo;
        this.cardSort = this.$route.query.cardSort;
    },
};
</script>

<style lang="scss" scoped>
/deep/.van-button--normal{
    width: 80%;
    display: block;
    margin: 0 auto;
    margin-top:50px ;
}
.container {
    background-color: #fff;
}

.step {
    background-color: #fff;
}

/deep/.van-steps--horizontal {
    width: 80%;
    margin: 0 auto;
}

.photo {
    margin-top: 20px;
}



    .item {
        margin: 30px 0;
        display: flex;

        .label {
            // padding-top: 10px;
            width: 230px;
            font-size: 0.37333rem;
            color: #646566;
        }

        input {
            margin-top: 20px;
            width: 260px;
            height: 40px;
            color: #999;
            padding-left: 10px;
            margin-right: 50px;
            border: 1px solid rgb(187, 185, 185);
        }
    }


.Verification {
    margin-top: 20px;
    width: 155px;
    height: 40px;
    background: rgb(202, 199, 199);
    display: flex;
    align-items: center;

    span {
        color: #2283e2;
    }
}

.btn {
    width: 110px;
    height: 45px;
    margin: 0 auto;
    line-height: 45px;
    font-size: 16px;
    color: #fff;
    border-radius: 5px;
    background: #2283e2;
    text-align: center;
    margin-top: 50px;
}

/deep/.el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 110px;
}
</style>
